<ng-template>
	<div
		(@transformPopover.done)="_onAnimationDone($event)"
		[@transformPopover]="{ value: state, params: params }"
		[ngClass]="_classList"
		#focusTrapElement
		class="sat-popover-container"
	>
		<mat-card class="mat-elevation-z6 flex flex-col">
			<mat-form-field
				appearance="fill"
				class="mat-form-field-no-hint mat-form-field-compact mat-form-field-plain w-full"
			>
				<mat-icon matPrefix>search</mat-icon>
				<input
					[formControl]="search"
					[placeholder]="'reports.filter.usersearch' | translate"
					matInput
					type="text"
				>
				<button
					(click)="search.setValue('')"
					*ngIf="search?.value"
					mat-icon-button
					matSuffix
				>
					<mat-icon>clear</mat-icon>
				</button>
			</mat-form-field>
			<div class="mt-1 flex flex-row items-center justify-start gap-2">
				<mat-checkbox
					(click.prevent)="showRemovedUsers.next(!showRemovedUsers.value)"
					[checked]="showRemovedUsers.value"
					*ngIf="reportsService"
					color="primary"
				>
					<div class="flex items-center space-x-1">
						<span>{{ 'workspace.users.removed' | translate }}</span>
					</div>
				</mat-checkbox>
				<div class="!ml-auto flex flex-row items-center justify-start">
					<div
						(click)="this.selectAll()"
						class="cursor-pointer p-2 text-sm font-bold"
						translate
					>
						reports.toggles.all
					</div>
					<div
						(click)="this.selectNone()"
						class="cursor-pointer p-2 text-sm font-bold"
						translate
					>
						reports.toggles.none
					</div>
				</div>
			</div>
			<div class="-mx-16px"><mat-divider inset></mat-divider></div>
			<mat-list class="-mx-16px pt-0">
				@if (!(items$filtered.value$ | async)?.length) {
				<div class="flex items-center justify-center px-4 py-2 text-center text-sm mat-hint">
					{{ 'utils.noitems-users' | translate }}
				</div>
				} @if (currentUserItem$filtered.value$ | async; as currentUserItem) {
				<mat-list-item
					(click)="$event.preventDefault(); $event.stopPropagation(); this.selectItem(currentUserItem.id)"
					(keydown.enter)="$event.preventDefault(); $event.stopPropagation(); this.close()"
					(keydown.space)="$event.preventDefault(); $event.stopPropagation(); this.selectItem(currentUserItem.id)"
					class="cursor-pointer"
					matRipple
				>
					<div class="flex-mw flex flex-row flex-auto items-center justify-start gap-2">
						<mat-checkbox
							[checked]="currentUserItem.selected"
							class="mat-checkbox-flex"
							color="primary"
						></mat-checkbox>
						<app-user-avatar
							[userId]="currentUserItem.id"
							class="rounded-full pr-1"
							size="24px"
						></app-user-avatar>
						<span class="mat-truncate flex-auto">{{ currentUserItem.name }}</span>

						<div class="flex flex-row justify-end gap-2">
							@if (currentUserItem.subordinate && !hideSubordinateIcon) {
							<div class="size-6 flex-center mat-bg-5 rounded-full">
								<mat-icon
									[matTooltip]="'workspace.supervisors.subordinates' | translate"
									inline
								>
									supervisor_account
								</mat-icon>
							</div>
							} @if (currentUserItem.removed) {
							<div class="size-6 flex-center mat-bg-5 rounded-full">
								<mat-icon
									[matTooltip]="'workspace.users.removed' | translate"
									inline
								>
									person_off
								</mat-icon>
							</div>
							}
						</div>
					</div>
				</mat-list-item>
				@if ((otherItems$filtered.value$ | async)?.length) {
				<mat-divider inset></mat-divider>
				} }
				<cdk-virtual-scroll-viewport
					[itemSize]="48"
					class="h-64"
				>
					<mat-list-item
						(click)="$event.preventDefault(); $event.stopPropagation(); this.selectItem(item.id)"
						(keydown.enter)="$event.preventDefault(); $event.stopPropagation(); this.close()"
						(keydown.space)="$event.preventDefault(); $event.stopPropagation(); this.selectItem(item.id)"
						*cdkVirtualFor="let item of otherItems$filtered.value$ | async; trackBy: trackId"
						class="cursor-pointer"
						matRipple
					>
						<div class="flex-mw flex flex-row flex-auto items-center justify-start gap-2">
							<mat-checkbox
								[checked]="item.selected"
								class="mat-checkbox-flex"
								color="primary"
							></mat-checkbox>
							<app-user-avatar
								[userId]="item.id"
								class="rounded-full pr-1"
								size="24px"
							></app-user-avatar>
							<span class="mat-truncate flex-auto">{{ item.name }}</span>

							<div class="flex flex-row justify-end gap-2">
								@if (item.subordinate && !hideSubordinateIcon) {
								<div class="size-6 flex-center mat-bg-5 rounded-full">
									<mat-icon
										[matTooltip]="'workspace.supervisors.subordinates' | translate"
										inline
									>
										supervisor_account
									</mat-icon>
								</div>
								} @if (item.removed) {
								<div class="size-6 flex-center mat-bg-5 rounded-full">
									<mat-icon
										[matTooltip]="'workspace.users.removed' | translate"
										inline
									>
										person_off
									</mat-icon>
								</div>
								}
							</div>
						</div>
					</mat-list-item>
				</cdk-virtual-scroll-viewport>
			</mat-list>
		</mat-card>
	</div>
</ng-template>
